import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "@ipc/ipc-core";
import AuthInfo from "../AuthInfo";
import { constructPublicAssetPath } from "../../../core/modules/common/tools/URLTools";
import { getIsAdmin } from "../../../modules/user/redux/selectors/UserReportSelectors";
import Settings from "../../../core/modules/common/components/Settings";
import CapeUserGuideLinkContainer from "../../../core/modules/common/components/CapeUserGuideLinkContainer";
import { httpOnlySecurityService } from "../../../externals/iam";

const mapStateToProps = (state) => ({
  isAdmin: getIsAdmin(state),
  asd: state,
});

// eslint-disable-next-line react/prefer-stateless-function
export class AppHeaderRightContainer extends Component {
  render() {
    const { isAdmin } = this.props;
    const logged = httpOnlySecurityService.isUserAuthenticated();

    const { pathname } = this.props.location || "";
    return (
      <div className="header-right-container">
        <AuthInfo />
        <Settings
          loggedIn={
            logged &&
            isAdmin !== "" &&
            isAdmin &&
            pathname.includes("report-definitions")
          }
        />
        <CapeUserGuideLinkContainer loggedIn={logged} />
        <div className="vertical-divider" />
        <a href="https://www.ipc.be/" target="_blank">
          <img
            className="logo"
            alt="IPC logo"
            src={constructPublicAssetPath("images/app/ipc_logo_small.png")}
          />
        </a>
      </div>
    );
  }
}

AppHeaderRightContainer.propTypes = {
  isAdmin: PropTypes.bool,
};

export default connect(mapStateToProps)(withRouter(AppHeaderRightContainer));
